import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "./redux/blockchain/blockchainActions";
import { fetchData } from "./redux/data/dataActions";

import Content from './components/Content'
import Revolution from "./components/Revolution";
import Foot from "./components/Foot";


const truncate = (input, len) =>
  input.length > len ? `${input.substring(0, len)}...` : input;

export default function Home() {

  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [claimingNft, setClaimingNft] = useState(false);
  // const [feedback, setFeedback] = useState(`Click button bellow to mint your`);
  const [feedback, setFeedback] = useState('');
  const [mintAmount, setMintAmount] = useState(1);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    // GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const claimNFTs = () => {
    let cost = CONFIG.WEI_COST;
    let totalCostWei = String(cost * mintAmount);
    // let gasLimit = CONFIG.GAS_LIMIT;
    // let totalGasLimit = String(gasLimit * mintAmount);
    console.log("Cost: ", totalCostWei);
    // console.log("Gas limit: ", totalGasLimit);
    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);
    blockchain.smartContract.methods
      .mintToken(mintAmount)
      .send({
        // gasLimit: String(totalGasLimit),
        to: CONFIG.CONTRACT_ADDRESS,
        from: blockchain.account,
        value: totalCostWei,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `✅ Transaction successful, Go check your ${CONFIG.NFT_NAME} on Opensea.io/collection/birdpassnft`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 5) {
      newMintAmount = 5;
    }
    setMintAmount(newMintAmount);
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
  }, [blockchain.account]);

  return (
    <>
      <head>
        <title>Bird Pass NFT</title>
        <meta name="description" content="Bird Pass NFT Dapp" />
        <link rel="icon" href="/favicon.png" />
      </head>

      {/* Header */}
      <header className='fixed w-full top-0 lg:px-8 px-5 pt-4 pb-3 z-70 backdrop-blur-sm transition-colors duration-500 z-40 flex-none md:z-50 bg-white  shadow-md '>
      
        {/* Header Container */}
        <div className='flex h-full items-center justify-center mx-auto border-opacity-0'>
            
          {/* Logo Section */}
          <div className='flex-grow'>
            <div className='flex'>
              <div className='w-min-content'>
                <a href='/' className='flex'>
                  <img alt='' src='/images/logo.png' className='h-10'/>
                  <p className='h-7 px-2 pt-1 pb-1 rounded uppercase text-lg font-black
                  text-black hidden md:flex'>
                     {/* Bird Pass */}
                  </p>
                </a>
              </div>
            </div>
          </div>

          {/* Desktop Navbar Section + Connect Wallet + icons */}
          <div className='items-center md:flex text-sm'>
            <ul className='flex space-x-2'>

              {/* CONNECT WALLET */}
              <li className="flex items-center justify-center pt-1">
              {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                <div className="flex flex-col items-center justify-center">
                  {/* Connect Wallet Button */}
                      <button className="px-4 bg-opacity-20 text-gray-900 font-semibold items-center relative h-7 tracking-wider pt-0.5 first::pt-0 duration-500 text-sm md:text-base padding-huge opacity-100 hover:bg-opacity-70 rounded flex justify-center flex-row bg-gradient-to-tr from-green-400 to-blue-400 bg-bluee hover:from-green-400 border-none hover:to-bluee hover:shadow-green-500/20 cursor-pointer"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(connect());
                      getData();
                    }}
                  >
                    CONNECT WALLET
                  </button>
                  <div>
                  {blockchain.errorMsg !== "" ? (
                    <>
                      <p style={{ textAlign: "center", color: "black", fontSize: "20px" }}>
                        {blockchain.errorMsg}
                      </p>
                    </>
                  ) : null}
                  </div> 
                </div>
              ) : (
                <>
                <span className="px-5 bg-opacity-20 text-gray-900 items-center relative h-7 tracking-wider pt-0.5 first::pt-0 duration-500 text-sm md:text-lg padding-huge opacity-100 hover:bg-opacity-70 rounded flex justify-center flex-row border border-bluee hover:shadow-green-500/20 cursor-pointer'">🦊 Connected{" "}
                {String(blockchain.account).substring(0, 6)}{"....."}
                </span></>
              )}
              </li>

              {/* Twitter Icon */}
              <li className='hidden md:flex'>
              {/* <li className='flex'> */}
                <a className='bg-opacity-20 text-black opacity-80 items-center relative h-7 tracking-wider pt-0.5 first::pt-0 uppercase text-2xs font-500 padding-huge bg-white duration-200 px-4 hover:bg-opacity-70 rounded flex justify-center flex-row transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110' href='https://twitter.com/BirdPassNFT' target='_blank' rel='noreferrer'>
                  <svg xmlns="http://www.w3.org/2000/svg" className=" fill-current stroke-current h-6 w-6" viewBox="0 0 40 40"><path d="M38.526 8.625a15.199 15.199 0 01-4.373 1.198 7.625 7.625 0 003.348-4.211 15.25 15.25 0 01-4.835 1.847 7.6 7.6 0 00-5.557-2.404c-4.915 0-8.526 4.586-7.416 9.346-6.325-.317-11.934-3.347-15.69-7.953C2.01 9.869 2.97 14.345 6.358 16.612a7.58 7.58 0 01-3.446-.953c-.084 3.527 2.444 6.826 6.105 7.56a7.63 7.63 0 01-3.438.13 7.618 7.618 0 007.112 5.286A15.306 15.306 0 011.42 31.79a21.55 21.55 0 0011.67 3.42c14.134 0 22.12-11.937 21.637-22.643a15.499 15.499 0 003.799-3.941z"></path></svg>
                </a>
              </li>
              {/* Discord Icon */}
              <li className='hidden md:flex'>
                <p className='bg-opacity-20 text-black opacity-80 items-center relative h-7 tracking-wider pt-0.5 first::pt-0 uppercase text-2xs font-500 padding-huge bg-white duration-200 px-4 hover:bg-opacity-70 rounded flex justify-center flex-row cursor-pointer transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110'>
                  <span className="text-black text-xs hidden hover:visible absolute top-[-6px]">Closed </span>
                  <svg xmlns="http://www.w3.org/2000/svg" className="fill-current stroke-current h-6 w-6" viewBox="0 0 40 40"><path d="M33.567 7.554a32.283 32.283 0 00-7.969-2.472.12.12 0 00-.128.06c-.344.613-.725 1.411-.992 2.039a29.804 29.804 0 00-8.95 0 20.625 20.625 0 00-1.008-2.038.126.126 0 00-.128-.06 32.194 32.194 0 00-7.968 2.47.114.114 0 00-.053.046C1.296 15.18-.095 22.577.588 29.88c.003.036.023.07.05.092 3.349 2.459 6.593 3.952 9.776 4.941a.127.127 0 00.137-.045 23.203 23.203 0 002-3.253.124.124 0 00-.068-.172A21.379 21.379 0 019.43 29.99a.126.126 0 01-.012-.209c.205-.153.41-.313.607-.475a.121.121 0 01.126-.017c6.407 2.925 13.343 2.925 19.675 0a.12.12 0 01.128.015c.196.162.4.324.608.477a.126.126 0 01-.011.209c-.975.57-1.99 1.051-3.055 1.454a.125.125 0 00-.067.173 26.052 26.052 0 001.998 3.252c.031.043.087.062.138.046 3.199-.99 6.442-2.482 9.79-4.941a.126.126 0 00.052-.09c.816-8.445-1.368-15.78-5.789-22.283a.1.1 0 00-.05-.046zm-20.06 17.88c-1.928 0-3.517-1.771-3.517-3.946 0-2.175 1.558-3.946 3.518-3.946 1.975 0 3.549 1.787 3.518 3.946 0 2.175-1.558 3.946-3.518 3.946zm13.01 0c-1.93 0-3.52-1.771-3.52-3.946 0-2.175 1.56-3.946 3.52-3.946 1.974 0 3.548 1.787 3.517 3.946 0 2.175-1.543 3.946-3.518 3.946z"></path></svg>
                </p>
              </li>
            </ul>
          </div>

        </div>
      </header>

      {/* Hero/Mint Section */}
      <section className="flex items-center justify-center bg-pattern py-12 px-5 overflow-hidden relative z-10">
      <div className="">
        {/* margin between header and hero section */}
        <div className="mb-5 flex items-center max-w-md mt-4 pt-2"></div>

        <div className="flex flex-col items-center justify-center md:flex-row md:items-center md:justify-between text-slate-900 -mx-4">

          {/* Left Hero Section - Mint Info */}
          <div className="left-section w-full md:w-1/2 xl:w-6/12 px-4">
            <div className="max-w-[570px] mb-12 md:mb-0">
              <p className="text-3xl text-center md:text-6xl font-extrabold text-body-color leading-relaxed text-transparent bg-clip-text bg-gradient-to-tl from-green-400 via-sky-500 to-blue-500 uppercase mb-3 md:mb-8">
                BIRD PASS
              </p>
              {/* Total supply - Price info */}
              <div className='flex flex-col items-center justify-center text-black'>
                <div className='mb-4 bg-pattern flex items-center justify-between rounded-md w-11/12 mx-auto p-2 border-2 border-cyan transition ease-in-out duration-500'>
                    <p className='font-bold'>Total Supply:</p>
                    <p>888 Passes</p>
                </div>
                <div className='mb-4 bg-pattern flex items-center justify-between rounded-md w-11/12 mx-auto p-2 border-2 border-cyan transition ease-in-out duration-500'>
                  <p className='font-bold'>Price Per Mint:</p>
                  <p>0.08 ETH</p>
                </div>
                <div className='mb-4 bg-pattern flex items-center justify-between rounded-md w-11/12 mx-auto p-2 border-2 border-cyan transition ease-in-out duration-500'>
                  <p className='font-bold'>Access Duration:</p>
                  <p>Lifetime</p>
                </div>
              </div>

              {/* Connect Wallet +/- increment & decrement / Mint button */}
              <div>
              {Number(data.totalSupply) >= CONFIG.MAX_SUPPLY ? (
                // Case when Sale End
              <>
                <h1 style={{ textAlign: "center", color: "black", fontSize: "20px" }}>
                  The sale has ended.
                </h1>
                <p className="m-4" style={{ textAlign: "center", color: "black", fontSize: "20px" }}>
                  You can still find {CONFIG.NFT_NAME} on
                </p>
                <a target="_blank" href={CONFIG.MARKETPLACE_LINK}>
                  {CONFIG.MARKETPLACE}
                </a>
              </>
              ) : (
                <>
                {blockchain.account === "" ||
                blockchain.smartContract === null ? (
                  <div className="flex flex-col items-center justify-center">
                    {/* Connect Wallet Button */}
                    <button
                      className="text-center flex flex-col font-semibold bg-gradient-to-r from-green-400 to-blue-500 border-none hover:shadow-green-500/20 cursor-pointer rounded py-3 px-5 text-base md:text-2xl text-body-color leading-relaxed m-3 md:m-8"
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch(connect());
                        getData();
                      }}
                    >
                      CONNECT WALLET
                    </button>
                    <div>
                      {blockchain.errorMsg !== "" ? (
                        <>
                          <p style={{ textAlign: "center", color: "black", fontSize: "20px"}}>
                            {blockchain.errorMsg}
                          </p>
                        </>
                      ) : null}
                    </div>
                  </div>
                ) : (
                  <>         
                    {/* Info Total Minted */}
                    <div className='mb-4 bg-pattern flex items-center justify-between rounded-md w-11/12 mx-auto p-2 border-2 border-cyan transition ease-in-out duration-500'>
                      <p className='font-bold'>Total Minted:</p>
                      <p><span className="text-bluee">{Number.parseFloat(0.08 * mintAmount)}</span>{" "}ETH + Gas</p>
                    </div>
                    
                    {/* Increment / Decrement Section */}
                    <div className="mx-10 flex items-center justify-evenly mb-5">
                      <button className='button w-10 h-10 flex items-center justify-center text-white text-base hover:shadow-lg bg-black font-bold rounded-md border border-opacity-80 border-cyan-600' 
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          decrementMintAmount();
                        }}
                      >
                      ــ
                      </button>
                      <p className="flex items-center justify-center text-center font-bold text-bluee text-2xl md:text-3xl">
                        {mintAmount}
                        {/* 1 */}
                      </p>
                      <button className="button w-10 h-10 flex items-center justify-center text-white text-2xl hover:shadow-lg bg-black font-bold rounded-md border border-opacity-80 border-cyan-600" 
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                           e.preventDefault();
                           incrementMintAmount();
                        }}
                      >
                      +
                      </button>
                    </div>     
                    
                    {/* <p className="" style={{textAlign: "center",color: "black",fontSize: "20px"}}>
                      {feedback}
                    </p> */}
                    
                    {/* Mint Now Button */}
                    <div className="flex items-center justify-center">
                      <button
                        className="text-center flex flex-col font-bold bg-gradient-to-r from-green-400 to-blue-500 border-none hover:shadow-green-500/20 cursor-pointer rounded py-3 px-12 text-base md:text-2xl text-body-color leading-relaxed m-3"
                        disabled={claimingNft ? 1 : 0}
                        onClick={(e) => {
                          e.preventDefault();
                          claimNFTs();
                          getData();
                        }}
                      >
                        {claimingNft ? "Minting.." : "MINT NOW"}
                      </button>
                    </div>
                    
                    <p className="" style={{textAlign: "center",color: "black",fontSize: "20px"}}>
                      {feedback}
                    </p>
                  </>
                )}
                </>
              )}
              </div>
              {/* End Connect Wallet / MINT Section */}
            </div>

          </div>
 
          {/* Right Hero Section - Video/Image Bird PASS */}
          <div className="right-section w-full md:w-1/2 xl:w-6/12 px-4">
            <div className="relative rounded-md p-8 shadow-md">
              <video autoPlay loop muted poster='/images/bird-pass.jpeg' className='w-[560px] vid hidden md:block'>
                <source src='/images/bird-pass.mp4' type='video/mp4' />
              </video> 
              <img src='/images/bird-pass.jpeg' alt='pass image' className='w-560 md:hidden flex items-center justify-center'/>
            </div>
          </div>
        </div>
      </div>
      </section>

      {/* Content + footer Section */}
      <Revolution/>
      <Content />
      <Foot/>
    </>
  )
}
